/**
 * DB缓存插件
 * https://localforage.docschina.org
 */
import localforage from 'localforage'
import MD5 from 'crypto-js/md5'

const orderdb = localforage.createInstance({
  name: 'question',
  storeName: 'order',
})

const versiondb = localforage.createInstance({
  name: 'question',
  storeName: 'versions',
})

function nowDateString () {
  return filter.formatDate(new Date())
}

export default {
  max: 3,
  getItem (key) {
    return new Promise((resolve, reject) => {
      orderdb.getItem(key).then((versions) => {
        if (versions) {
          let {key} = versions.pop()
          this.getVersionItem(key).then(resolve, reject)
        } else {
          reject(new Error(key + ' 数据不存在'))
        }
      }, reject)
    })
  },
  setItem (key, data) {
    return new Promise((resolve, reject) => {
      orderdb.getItem('temp').then((temp) => {
        if (temp) {
          this.setTempItem(key, data, temp.created_at).then(resolve, reject)
        } else {
          this.setTempItem(key, data).then(resolve, reject)
        }
      }, reject)
    })
  },
  moveTempToVersionItem () {
    return new Promise((resolve, reject) => {
      orderdb.getItem('temp').then((temp) => {
        if (temp) {
          // 删除临时缓存
          orderdb.removeItem('temp')
          // 移动临时缓存到持久缓存
          this.setVersionItem(temp.key, temp).then(resolve, reject)
        }
      }, reject)
    })
  },
  setVersionItem (key, tempCache) {
    return new Promise((resolve, reject) => {
      // 清理列表后继续
      this.clean(key).then(() => {
        orderdb.getItem(key).then((versionItems) => {
          // 生成版本 key name
          let versionKey = key + '_' + MD5(JSON.stringify(tempCache.data)).toString()
          // 生成一个审核版本列表的缓存数据
          let order = this.makeOrderItem(versionItems, versionKey, tempCache)
          // 保存工单的审核版本列表数据
          this.setOrderItem(key, order.versions).then(() => {
            // 版本内容是否变更
            if (order.index === -1) {
              // 保存版本数据
              versiondb.setItem(versionKey, tempCache.data).then(resolve, reject)
            }
          }, reject)
        }, reject)
      }, reject)
    })
  },
  clean (key) {
    return new Promise((resolve, reject) => {
      orderdb.getItem('items').then((orderKeys) => {
        // 不存在则创建
        if (!orderKeys) {
          return orderdb.setItem('items', []).then(resolve, reject)
        }
        // 缓存在列表中 或 缓存数量在允许范围
        if (orderKeys.includes(key) || orderKeys.length < this.max) {
          return resolve()
        }
        // 删除旧的缓存
        if (orderKeys && orderKeys.length) {
          let orderKey = orderKeys.shift()
          // 更新缓存列表
          orderdb.setItem('items', orderKeys).then(resolve, reject)
          // 删除缓存
          orderdb.getItem(orderKey).then((versions) => {
            // 删除版本缓存
            if (versions) {
              this.removeVersionItems(versions)
            }
            orderdb.removeItem(orderKey)
          }, reject)
        }
      }, reject)
    })
  },
  setTempItem (key, data, createdAt) {
    return new Promise((resolve, reject) => {
      orderdb.setItem('temp', {
        key,
        data,
        created_at: createdAt || nowDateString(),
        updated_at: nowDateString(),
      }).then(resolve, reject)
    })
  },
  getVersionItem (key) {
    return versiondb.getItem(key)
  },
  removeVersionItems (keys) {
    keys.forEach(({key}) => {
      versiondb.removeItem(key)
    })
  },
  getOrderItem (key) {
    return orderdb.getItem(key)
  },
  setOrderItem (key, value) {
    return new Promise((resolve, reject) => {
      orderdb.getItem('items').then((keys) => {
        !keys && (keys = [])
        if (!keys.includes(key)) {
          keys.push(key)
          orderdb.setItem('items', keys).then(() => {
            orderdb.setItem(key, value).then(resolve, reject)
          }, reject)
        } else {
          orderdb.setItem(key, value).then(resolve, reject)
        }
      })
    })
  },
  makeOrderItem (versions, versionKey, tempCache) {
    let _versions = versions ? JSON.parse(JSON.stringify(versions)) : []
    // 版本key是否已存在
    let index = _versions.map(({key}) => key).indexOf(versionKey)
    if (index === -1) {
      _versions.push({
        key: versionKey,
        created_at: tempCache.created_at || nowDateString(),
        updated_at: tempCache.updated_at,
      })
    } else {
      // 存在则更新相关信息
      let _version = _versions[index]
      _version.updated_at = tempCache.updated_at || nowDateString()
      _versions.splice(index, 1)
      _versions.push(_version)
    }
    return {
      index,
      versions: _versions,
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/question-review/components/CacheManage/cache-db.js